import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jcomm(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>

<Sides/>
<Helmet>
 
  <title>Master the Art of Java Commenting: A Beginner's Tutorial by CodeExampler</title>
<meta name="description" content="Boost your Java coding skills with CodeExampler's beginner-friendly Java Commenting tutorial. Learn how to write clear and concise comments, use different types of comments,Start commenting like a pro and take your coding to the next level today!" />
<meta name="keywords" content="codeexampler, java commenting tutorial, java comment syntax, java comment types, javadoc comment,multi line comment in java beginner programming tutorial,multiline comments in java" />
<link rel="canonical" href="https://www.codeexampler.com/java-comments" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Types Of Comment In Java</h1>
    <div className="first">
        <a href="/java-types-of-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="pt-4 para">1, Comments in Java are used only for you to read.
<br/>2, If you type any content inside Java, comments are ignored by the compiler
</p>
<h2 className="mt-4 mh2">Java Comments Examples:</h2>


<h2 className="headings">Java Comments Examples: </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-10">{`/*`} </span>
            <span className="qwerty-3">hello ram  </span>
            {"\n"}
            <span className="qwerty-3">Hello Bharat </span>
            <span className="qwerty-10">{`*/`}</span>

            {"\n"}  {"\n"}
          </code>
        </pre>
      </div>

<h2 className=" mt-4 mh2 ">There are three types of comments in a java programming language.</h2>
<h3 className="mt-4 mh3">1, Single-line comment<br/>
2, Multi-line comment<br/>
3, Documentation comment or JavaDoc comment

</h3>
<h2 className="mt-4 mh2">1, Single-line comment-</h2>
<p className="para mt-4">This single-line comment starts with a // tag and ends at the end of the line.</p>


<h2 className="headings">Single-line Comments in java example: </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-5">{`//`} </span>
            <span className="qwerty-3">my name is codeexampler.com  </span>
            {"\n"}
            <span className="qwerty-5">{`//`} </span>
            <span className="qwerty-3">this is a java programming </span>

            {"\n"}  {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">2, Multi-line Comment</h2>
<p className="para">That is a multi-line comment in Java, and This type of comment must begin with /* and end with */. If you write anything inside this comment, symbols ignore by the compiler.</p>


<h2 className="headings">Multi-line Comments in Java Example </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-10">{`/*`} </span>
          <span className="qwerty-3">my name is codeexampler.com  </span>
          {"\n"}
          <span className="qwerty-3">that is a java programming </span>
          <span className="qwerty-10">{`*/`}</span>

          {"\n"}  {"\n"}
        </code>
      </pre>
    </div>


<h2 className="mt-4 mh2">3, Documentation Comment or JavaDoc Comment-</h2>
<p className="para mt-4">This type of comment is used to create documentation comments, also known as <span className="bl">JavaDoc Comment.</span></p>


<h2 className="headings">Documentation or Javadoc Comment in Java Example:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-10">{`/*`} </span>
          <span className="qwerty-3">hello  </span>
          {"\n"}
          <span className="qwerty-3">My </span>
          {"\n"}
          <span className="qwerty-3">Name </span>
          {"\n"}
          <span className="qwerty-3">Is </span>
          {"\n"}
          <span className="qwerty-3">Code </span>
          {"\n"}
          <span className="qwerty-3">Exampler </span>
          {"\n"}
          <span className="qwerty-10">{`*/`}</span>

          {"\n"}  {"\n"}
        </code>
      </pre>
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-types-of-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jcomm;